import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate } from "react-router";
import api from "../../services/api";
import { formatDateWithTime } from "../../utils/dateFormat";
import NoDataFound from "../../shared/NoDataFound";
import { Toast } from "../../shared/Toast";
import { useDispatch, useSelector } from "react-redux";

import Paginator from "../../shared/Paginator";
import config from "../../config";
import TableLoader from "../../shared/TableLoader";
import {
  languageOptions,
  stateOptions,
  positionalRageOptions,
  roles,
  LocalPricePackages,
  pricePackages,
} from "../../utils/constants";
import { debounce } from "../../utils/Debounce";
import { parse } from "papaparse";
// import { ModalBody, ModalHeader, ModalTitle } from 'react-bootstrap';
import {
  SlButton,
  SlDrawer,
  SlInput,
  SlIcon,
} from "@shoelace-style/shoelace/dist/react";
import { SetComponentId } from "../../redux/counterSlice";

const initials = {
  lang_id: "",
  lang_name: "",
  zone_id: "",
  zone_name: "",
  package_type: "",
  positional_range: "",
  price: 0,
  creative_type: "",
  package_weeks: 0
};

let initialValues = JSON.parse(JSON.stringify(initials));

const schema = Yup.object().shape({
  lang_id: Yup.number().required("Language is required"),
  zone_id: Yup.number().required("Zone is required"),
  package_type: Yup.string().required("Package Type is required"),
  positional_range: Yup.string()
    .required("Range is required")
    .test("", "Range is required", (text) => {
      return text !== "";
    }),
  price: Yup.number()
    .required("Price is required")
    .min(1, "Must be greater than zero"),
  creative_type: Yup.string().required("Creative Type is required"),
  package_weeks: Yup.number().required("Package is required")
});
function ZonePoisitionalPrice(){

    const navigate = useNavigate();
    const [submit, setSubmit] = useState(false);
    const [zones, setZones] = useState([]);
  
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [loader, setLoader] = useState(false);
    const [fileLoader, setFileLoader] = useState(false);
  
    const [flag, setFlag] = useState("");
    const [id, setId] = useState("");
    const [search, setSearch] = useState("");
  
    const [view, setView] = useState(false);
    const [duplicatedata, setDuplicateData] = useState([]);
  
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(0);
    const HeaderSearch = useSelector((state) => state.Head.adssearch);
  
    const handlePageClick = (event) => {
      setCurrentPage(event.selected);
      loadData(search, event.selected);
    };
    const {
      register,
      setValue,
      formState: { errors },
    } = useForm({ mode: "onSubmit" });
  
    const handleClose = () => {
      setShow(false);
      setView(false);
      setSubmit(false);
      initialValues = JSON.parse(JSON.stringify(initials));
      formik.setValues(initialValues);
    };
  
    const loadData = async (searchString = "", page = 0) => {
      try {
        setLoader(true);
        let res = await api({
          url: `/location/getZonePositionalPrices`,
          method: "POST",
          responseType: "json",
          data: {
            page,
            limit: config.PER_PAGE,
            search: searchString,
          },
        });
        setData(res.data.data.length ? res.data.data : []);
        setTotalPages(Math.ceil(res.data.total / config.PER_PAGE));
        setLoader(false);
      } catch (error) {
        setLoader(false);
        if (error?.response?.status === 401) navigate("/");
      }
    };
  
    const searchData = (e) => {
      setSearch(e.target.value);
      setCurrentPage(0);
      loadData(e.target.value, 0);
    };
  
    useEffect(() => {
      Header();
    }, [HeaderSearch]);
  
    const Header = () => {
      setSearch(HeaderSearch);
      setCurrentPage(0);
      loadData(HeaderSearch, 0);
    };
  
    let formik = useFormik({
      initialValues: JSON.parse(JSON.stringify(initials)),
      validationSchema: schema,
      onSubmit: async (values) => {
        if (flag === "add") {
          try {
            let res = await api({
              url: `/location/addZonePositionalPrice`,
              method: "POST",
              responseType: "json",
              data: values,
            });
            if (res?.code === 200) {
              Toast("success", "Location Added Successfully");
              handleClose();
              setCurrentPage(0);
              setSearch("");
              loadData(search, 0);
            } else {
              Toast("error", res?.data?.message);
            }
          } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            if (error.response.status === 401) navigate("/");
          }
        }
        if (flag === "edit") {
          try {
            values.id = id;
            let res = await api({
              url: `/location/updateZonePositionalPrice`,
              method: "POST",
              responseType: "json",
              data: values,
            });
            if (res?.code === 200) {
              Toast("success", "Location updated Successfully");
              loadData(search, currentPage);
              handleClose();
              values = JSON.parse(JSON.stringify(initials));
            } else {
              Toast("error", res?.data?.message);
            }
          } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            if (error.response.status === 401) navigate("/");
          }
        }
      },
    });
  
    const handleShow = async (choose, item) => {
      if (choose === "add") {
        formik.setValues(initials);
        setShow(true);
      }
      if (choose === "edit") {
        initialValues.lang_id = item.lang_id;
        initialValues.lang_name = item.lang_name;
        item.lang_id && getZones(item.lang_id);
        initialValues.positional_range = item.positional_range;
        initialValues.creative_type = item.creative_type;
        initialValues.price = item.amount;
        initialValues.package_weeks = +item.package_weeks
        initialValues.package_type = item.package_type;
        initialValues.zone_id = item.zone_id;
        initialValues.zone_name = item.zone_name;
        formik.setValues(initialValues);
        setShow(true);
      }
    };
  
    const fileChange = async (e) => {
      const file = e.target.files[0];
      const type = e.target.value.split(".").pop();
      if (type === "csv") {
        setFileLoader(true);
        const reader = new FileReader();
  
        reader.onload = async () => {
          const jsonArray = parse(reader.result, { header: true }).data;
          try {
            let res = await api({
              url: `/location/addZonePositionalPricewithFile`,
              method: "POST",
              responseType: "json",
              data: jsonArray,
            });
            if (res.code === 200 && res.data.length > 0) {
              setView(true);
              setDuplicateData(res.data);
              Toast(
                "success",
                "Locations Added Successfully with out Duplicates"
              );
              setCurrentPage(0);
              setSearch("");
              loadData(search, 0);
            } else if (res?.code === 200) {
              Toast("success", "Locations Added Successfully");
              setCurrentPage(0);
              setSearch("");
              loadData(search, 0);
            } else {
              Toast("error", res?.message);
            }
          } catch (error) {
            let er = error?.response?.message || "Something went wrong";
            Toast("error", er);
            if (error.response.status === 401) navigate("/");
          } finally {
            setFileLoader(false);
          }
          setValue("file_csv", "");
        };
  
        reader.readAsText(file);
      } else {
        Toast("error", "Only csv files are allowed");
        setValue("file_csv", "");
      }
    };
  
    const getZones = async (lang_id) => {
        let zones = await api({
            url: `/location/getZones`,
            method: "POST",
            responseType: "json",
            data: { lang_id }
        }); 
        if(zones.code === 200){
            let arr = zones.data || [];
            setZones(arr);
        }
    };
  
    const onInputChange = (type, id) => {
      switch (type) {
        case "lang_id":
          formik.setFieldValue(
            "lang_name",
            languageOptions.find((j) => j.value === +id)?.label
            );
            formik.setFieldValue("zone_id", "");
            formik.setFieldValue("zone_name", "");
          break;
        case "zone_id":
          formik.setFieldValue(
            "zone_name",
            zones.find((j) => j.zone_id === +id)?.zone_name
          );
          break;
        
        default:
      }
    };
  
    return (
      <>
        <div className="flex items-center mb-3">
          <aside className="flex items-center gap-3 ml-auto flex-wrap w-full">
            <h5 className="mr-auto">Zone Positional Price</h5>
            <div>
              <SlInput
                size="small"
                id="myInput"
                onSlInput={debounce(searchData, 500)}
                placeholder="Search By Zone"
              >
                <SlIcon library="lucide" name="map-pin" slot="prefix"></SlIcon>
              </SlInput>
            </div>
            <div>
              {localStorage.getItem("role") === roles.financer && (
                <>
                  <SlButton
                    type="button"
                    size="small"
                    variant="primary"
                    onClick={() => {
                      handleShow("add", {});
                      setFlag("add");
                    }}
                  >
                    Add Zone Price
                  </SlButton>
                  <label htmlFor="file" className="m-0">
                    <i
                      className="bi bi-arrow-up-circle ml-3 px-2 py-1 rounded-lg  bg-slate-100 hover:text-cyan-500 cursor-pointer hover:bg-slate-150"
                      data-toggle="tooltip"
                      title="Upload Card Lists"
                    ></i>
                    <input
                      type="file"
                      id="file"
                      style={{ display: "none" }}
                      name="file"
                      {...register("file_csv", {
                        required: false,
                        onChange: (e) => fileChange(e),
                      })}
                    />
                  </label>
                  {fileLoader && (
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  )}
                </>
              )}
            </div>
          </aside>
        </div>
  
        <div className="overflow-x-auto mb-4">
          <table className="table table-bordered">
            <thead className="sticky top-0">
              <tr>
                <th>Language</th>
                <th>Zone</th>
                <th>Creative Type</th>
                <th>Position</th>
                <th>Package</th>
                <th>Package Type</th>
                <th>Amount</th>
                <th>Created Date</th>
                {localStorage.getItem("role") === roles.financer ? (
                  <th>Actions</th>
                ) : null}
              </tr>
            </thead>
            {data?.length && !loader ? (
              <tbody>
                {data.map((item) => {
                  return (
                    <tr key={item.id}>
                      <th>{item.lang_name}</th>
                      <td>{item.zone_name || "-"}</td>
                      <td>{item.creative_type || "-"}</td>
                      <td>{item.positional_range}</td>
                      <td>{`${item.package_weeks} ${item.package_weeks > 1 ? 'Weeks' : 'Week'}`}</td>
                      <td>{item.package_type || "-"}</td>
                      <td>{`₹${item.amount}`}</td>
                      <td> {formatDateWithTime(item.created_date)}</td>
                      {localStorage.getItem("role") === roles.financer ? (
                        <td>
                          <sl-tooltip content="Edit Zone Price">
                            <sl-icon-button
                              library="lucide"
                              name="edit"
                              onClick={() => {
                                handleShow("edit", item);
                                setFlag("edit");
                                setId(item.id);
                              }}
                            ></sl-icon-button>
                          </sl-tooltip>
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
            ) : !data?.length && !loader ? (
              <NoDataFound colspan="8" />
            ) : (
              <TableLoader colspan="8" />
            )}
          </table>
        </div>
        <div className="flex justify-end">
          {totalPages > 1 && (
            <Paginator
              pageCount={totalPages}
              handlePageClick={handlePageClick}
              forcePage={currentPage}
            />
          )}
        </div>
  
        <Modal show={show} onHide={handleClose} animation={false}>
          <Modal.Header closeButton>
            <Modal.Title>Add Zone Price</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-3">
                <label className="mb-1"> Languages </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  name="lang_id"
                  placeholder="Select Language"
                  onBlur={formik.handleBlur}
                  value={formik.values.lang_id}
                  onChange={(e) => {
                    formik.handleChange(e);
                    getZones(e.target.value);
                    onInputChange("lang_id", e.target.value);
                  }}
                >
                  <option value="">Select Option</option>
                  {languageOptions.map((item) => {
                    return (
                      <option value={item.value} key={item.value}>
                        {item.label}
                      </option>
                    );
                  })}
                </select>
                {submit && formik.errors.lang_id && formik.touched.lang_id ? (
                  <div className="text-red-600">{formik.errors.lang_id}</div>
                ) : null}
              </div>
  
              <div className="mb-3">
                <label> Zones </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  name="zone_id"
                  placeholder="Select Language"
                  onBlur={formik.handleBlur}
                  value={formik.values.zone_id}
                  onChange={(e) => {
                    formik.handleChange(e);
                    onInputChange("zone_id", e.target.value);
                  }}
                >
                  <option value="">Select Option</option>
                  {zones.map((item) => {
                    return (
                      <option value={item.zone_id} key={item.zone_id}>
                        {item.zone_name}
                      </option>
                    );
                  })}
                </select>
                {submit && formik.errors.zone_id && formik.touched.zone_id ? (
                  <div className="text-red-600">{formik.errors.zone_id}</div>
                ) : null}
              </div>
  
              <div className="mb-3">
                <label> Package Type </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  name="package_type"
                  placeholder="Select Language"
                  onBlur={formik.handleBlur}
                  value={formik.values.package_type}
                  onChange={(e) => {
                    formik.handleChange(e);
                    formik.setFieldValue("package_type", e.target.value);
                    formik.setFieldValue("package_weeks", 0);
                  }}
                >
                  <option value="">Select Option</option>
                  <option value="Local">Local</option>
                  <option value="Alpha">Alpha</option>
                  <option value="Classified">Classified</option>
                  <option value="Regular">Regular</option>
                </select>
                {submit &&
                formik.errors.package_type &&
                formik.touched.package_type ? (
                  <div className="text-red-600">{formik.errors.package_type}</div>
                ) : null}
              </div>
  
              <div className="mb-3">
                <label> Creative Type </label>
                <select
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.creative_type}
                  name="creative_type"
                  className="form-select"
                  aria-label="Default select example"
                >
                  <option value="">select creative type</option>
                  <option value="Full Page">Full Page</option>
                  <option value="Full Page Video">Full Page Video</option>
                  <option value="Promoted Story">Promoted Story</option>
                </select>
                {submit &&
                formik.errors.creative_type &&
                formik.touched.creative_type ? (
                  <div className="text-red-600">
                    {formik.errors.creative_type}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label> Package </label>
                <select
                  onBlur={formik.handleBlur}
                  onChange={formik.handleChange}
                  value={formik.values.package_weeks}
                  name="package_weeks"
                  className="form-select"
                  aria-label="Default select example"
                >
                  {[{label: "Not a Package", value: 0},...LocalPricePackages, ...pricePackages].map(item => 
                      <option value={item.value}>{item.label}</option>
                  )}
                </select>
                {submit &&
                formik.errors.package_weeks &&
                formik.touched.package_weeks ? (
                  <div className="text-red-600">
                    {formik.errors.package_weeks}
                  </div>
                ) : null}
              </div>
              <div className="mb-3">
                <label> Position </label>
                <select
                  className="form-select"
                  aria-label="Default select example"
                  name="positional_range"
                  placeholder="Select Range"
                  onBlur={formik.handleBlur}
                  value={formik.values.positional_range}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                >
                  <option value="">Select Option</option>
                  {positionalRageOptions.map((item) => {
                        return (
                          <option value={item.value} key={item.value}>
                            {item.label}
                          </option>
                        );
                      })}
                      {/* {Array.from({length: 50}).map((item, index) => {
                    return <option value={index} key={index} >{`P ${index}`}</option>
                  })} */}
                </select>
                {submit &&
                formik.errors.positional_range &&
                formik.touched.positional_range ? (
                  <div className="text-red-600">
                    {formik.errors.positional_range}
                  </div>
                ) : null}
              </div>
  
              <div className="mb-3">
                <label>Amount</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Enter Amount"
                  aria-label=""
                  name="price"
                  value={formik.values.price}
                  onBlur={formik.handleBlur}
                  onChange={(e) => {
                    formik.handleChange(e);
                  }}
                />
                {submit && formik.errors.price && formik.touched.price ? (
                  <div className="text-red-600">{formik.errors.price}</div>
                ) : null}
              </div>
  
              <button
                type="submit"
                className="btn btn-primary"
                onClick={(e) => setSubmit(true)}
              >
                Submit
              </button>
            </form>
          </Modal.Body>
          <Modal.Footer></Modal.Footer>
        </Modal>
        <SlDrawer
          label="Invalid and Duplicate Records"
          open={view}
          onSlAfterHide={() => setView(false)}
          style={{ "--size": `${window.innerWidth <= 767 ? "100vw" : "50vw"}` }}
        >
          <div className="overflow-x-auto mb-4">
            <table className="table-base">
              <thead>
                <tr>
                  <th>Type</th>
                  <th>Language</th>
                  <th>Zone</th>
                  <th>Package Type</th>
                  <th>Creative Type</th>
                  <th>Position</th>
                  <th>Package</th>
                  <th>Amount</th>
                </tr>
              </thead>
              {console.log(duplicatedata)}
              {duplicatedata?.length && !loader ? (
                <tbody>
                  {duplicatedata?.map((item, index) => {
                    return (
                      <tr key={index}>
                        <td>{item.type}</td>
                        <th scope="row">{item.language}</th>
                        <td>{item.zone_name || "-"}</td>
                        <td>{item.package_type || "-"}</td>
                        <td>{item.creative_type || "-"}</td>
                        <td>{item.range}</td>
                        <td>{`${item.package_weeks} ${item.package_weeks > 1 ? 'Weeks' : 'Week'}`}</td>
                        <td>{`₹${item.amount}`}</td>
                      </tr>
                    );
                  })}
                </tbody>
              ) : !data?.length && !loader ? (
                <NoDataFound colspan="7" />
              ) : (
                <TableLoader colspan="7" />
              )}
            </table>
          </div>
          <SlButton
            slot="footer"
            variant="primary"
            onClick={() => setView(false)}
          >
            Close
          </SlButton>
        </SlDrawer>
      </>
    );
  }
  
export default ZonePoisitionalPrice